class Modal {
  ALLOWED_ORIGINS = ['https://cdn.shopify.com'];
  LOCATION_STORAGE_KEY = 'preferred-location';

  constructor() {
    this.modal = document.querySelector('#dreambaby-modal');
    this.modalTriggers = document.querySelectorAll(`[data-modal-trigger="dreambaby-modal"]`);
    this.closeButtons = this.modal.querySelectorAll('[data-modal-close]');
    this.isOpen = false;
    this.iframe = this.modal.querySelector('.product-form__buy-iframe');
    this.locationId = sessionStorage.getItem(this.LOCATION_STORAGE_KEY);
    this.loadingSkeleton = this.modal.querySelector('.modal__loading-skeleton');
    this.errorMessage = this.modal.querySelector('.iframe-error');
    this.addConfiguredGiftlistOrigin();

    this.modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => this.openModal());
    });

    this.closeButtons.forEach(button => {
      button.addEventListener('click', () => this.closeModal());
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen) {
        this.closeModal();
      }
    });

    window.addEventListener('message', (event) => this.handleIframeMessage(event));

    document.body.appendChild(this.modal);

    subscribe(PUB_SUB_EVENTS.variantChange, this.updateIframeUrl.bind(this));
  }

  addConfiguredGiftlistOrigin() {
    const giftlistDomain = window.DreambabyConfig && window.DreambabyConfig.giftlistDomain;

    if (!giftlistDomain) {
      return;
    }

    try {
      const origin = new URL(giftlistDomain).origin;

      if (!this.ALLOWED_ORIGINS.includes(origin)) {
        this.ALLOWED_ORIGINS.push(origin);
      }
    } catch (error) {
      console.warn('[Dreambaby Modal] Invalid giftlist domain configured:', giftlistDomain);
    }
  }

  updateIframeUrl(event) {
    if (!this.iframe) {
      return;
    }
    
    const variantSku = event.data.variant.sku;
    const variantId = event.data.variant.id;
    const parameters = new URLSearchParams(this.iframe.src.split('?')[1]);
    parameters.delete('productId');
    parameters.delete('productSku');
    parameters.set('productId', variantId);
    parameters.set('productSku', variantSku);

    this.iframe.src = `${this.iframe.src.split('?')[0]}?${parameters.toString()}`;
  }

  openModal() {
    if (this.iframe) {
      this.iframe.src = this.iframe.src + `&defaultPickupStoreId=${this.locationId}`;
    }

    this.modal.setAttribute('aria-hidden', 'false');
    this.isOpen = true;

    if (this.loadingSkeleton) {
      this.loadingSkeleton.classList.remove('hidden');
    }
    if (this.iframe) {
      this.iframe.classList.remove('loaded');
      this.iframe.style.display = '';
    }
    if (this.fallbackButton) {
      this.fallbackButton.classList.add('hidden');
    }
    if (this.errorMessage) {
      this.errorMessage.classList.add('hidden');
    }

    setTimeout(() => {
      // In some rare cases the iframe load does not trigger. In that case, we show a fallback.
      if (this.iframe.classList.contains('loaded')) {
        return;
      }

      if (this.iframe) {
        this.iframe.style.display = 'none';
      }
      if (this.loadingSkeleton) {
        this.loadingSkeleton.classList.add('hidden');
      }
      if (this.errorMessage) {
        this.errorMessage.classList.remove('hidden');
      }
      if (this.fallbackButton) {
        this.fallbackButton.classList.remove('hidden');
      }
    }, 2000);
  }

  closeModal() {
    this.modal.setAttribute('aria-hidden', 'true');
    this.isOpen = false;

    if (this.iframe) {
      // eslint-disable-next-line no-self-assign
      this.iframe.src = this.iframe.src;
    }
  }

  handleIframeMessage(event) {
    if (!this.ALLOWED_ORIGINS.includes(event.origin)) {
      return;
    }

    switch (event.data.type) {
      case 'buyButtonReady':
        this.handleLoadedEvent();
        break;
    }
  }

  handleLoadedEvent() {
    if (this.loadingSkeleton) {
      this.loadingSkeleton.classList.add('hidden');
    }
    if (this.iframe) {
      this.iframe.classList.add('loaded');
      this.iframe.style.display = '';
    }
    if (this.errorMessage) {
      this.errorMessage.classList.add('hidden');
    }
    if (this.fallbackButton) {
      this.fallbackButton.classList.add('hidden');
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new Modal());
} else {
  new Modal();
}
